import { JSX } from "react"

export default function CompanyIframe(): JSX.Element {
    return (
        <div className="col-lg-6">
            <div className="ratio ratio-16x9 shadow-lg rounded">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d144.95529914972022!2d17.0207587!3d54.457910299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fe1b0007f70fb1%3A0x8dcf2b69a0b6c651!2sM%26S%20A.S.%20Garage%20Sp%20z%20o.o.!5e0!3m2!1sen!2spl!4v1763477944522!5m2!1sen!2spl"
                    width="100%"
                    height="150"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade">

                </iframe>
            </div>
        </div>
    );
}